import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Dialog, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, resolveContent } from '@nu-art/ts-common';
import './Advisor_DialogConfirmation.scss';
import { ICONS } from '@app/styles';
export const AdvisorDialogConfirmationKey = 'advisor-confirmation-dialog';
export class Advisor_DialogConfirmation extends TS_Dialog {
    static defaultProps = {
        dialogId: AdvisorDialogConfirmationKey,
    };
    static show = (props) => {
        ModuleFE_Dialog.show({ content: _jsx(Advisor_DialogConfirmation, { ...props }) });
    };
    renderHeader = () => {
        return _jsx(ICONS.advisor_avn_close.component, { style: { marginLeft: 'auto' }, onClick: () => {
                this.props.cancelCallback?.();
                this.closeDialog();
            } });
    };
    renderBody = () => {
        return _jsx(_Fragment, { children: resolveContent(this.props.content) });
    };
    buttons = () => {
        if (!this.props.customButtons && !this.props.confirmCallback)
            throw new BadImplementationException('it is a must to provide custom buttons or confirmation callback');
        if (this.props.customButtons)
            return this.props.customButtons;
        return {
            center: [
                {
                    content: this.props.cancelButtonLabel ?? 'Cancel', // use label from props or default
                    variant: 'secondary',
                    onClick: () => {
                        this.props.cancelCallback?.();
                        this.closeDialog();
                    },
                },
                {
                    content: this.props.confirmButtonLabel ?? 'Proceed', // use label from props or default
                    variant: 'primary',
                    onClick: async () => {
                        await this.props.confirmCallback();
                        this.closeDialog();
                    },
                },
            ]
        };
    };
}
//# sourceMappingURL=Advisor_DialogConfirmation.js.map